import React, { useState } from 'react';
import { joinSession } from '../sessionService';
import { Session } from '../types';

interface JoinScreenProps {
  onSessionJoined: (sessionCode: string, userName: string, user: 'userB', session: Session) => void;
  onBack: () => void;
}

const JoinScreen: React.FC<JoinScreenProps> = ({ onSessionJoined, onBack }) => {
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleJoin = async () => {
    if (!name.trim()) { setError('Please enter your name.'); return; }
    if (code.trim().length < 6) { setError('Please enter a valid 6-character session code.'); return; }

    setLoading(true);
    setError('');

    try {
      const session = await joinSession(code.trim(), name.trim());
      onSessionJoined(code.trim().toUpperCase(), name.trim(), 'userB', session);
    } catch (err: any) {
      setError(err.message || 'Something went wrong. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-6 py-12 bg-dinder-blue">
      <div className="w-full max-w-sm">

        <div className="text-center mb-10">
          <h1 className="text-5xl font-extrabold text-white mb-1">Join Session</h1>
          <p className="text-blue-100 text-sm mt-2">Enter the code your partner shared with you</p>
        </div>

        <div className="space-y-4">
          <input
            type="text"
            placeholder="Your first name"
            value={name}
            onChange={e => setName(e.target.value)}
            className="w-full bg-white/20 border border-white/30 rounded-2xl px-4 py-4 text-white placeholder-white/60 text-lg focus:outline-none focus:border-white"
          />
          <input
            type="text"
            placeholder="Session code (e.g. A3BX7K)"
            value={code}
            onChange={e => setCode(e.target.value.toUpperCase().slice(0, 6))}
            className="w-full bg-white/20 border border-white/30 rounded-2xl px-4 py-4 text-white placeholder-white/60 text-lg text-center tracking-widest font-bold focus:outline-none focus:border-white"
          />

          {error && <p className="text-red-200 text-sm text-center">{error}</p>}

          <button
            onClick={handleJoin}
            disabled={loading}
            className="w-full bg-dinder-pink text-white font-bold text-xl py-4 rounded-2xl mt-2 disabled:opacity-50 transition-all active:scale-95"
          >
            {loading ? 'Joining...' : 'Join Session'}
          </button>
        </div>

        <button
          onClick={onBack}
          className="w-full mt-4 text-white/50 font-semibold text-lg py-4 rounded-2xl transition-all active:scale-95"
        >
          ← Back
        </button>

      </div>
    </div>
  );
};

export default JoinScreen;